import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

// Hooks
import { useFetchUser } from "../../../hooks/useFetchUser";

// Firebase
import { firestore } from "../../../firebase/firebase";
import { getDoc, doc as firebaseDoc, updateDoc } from "firebase/firestore";
import { genDoc } from "../../../firebase/requests";

// interfaces
import { completeChapter, isChapterCompleted } from "../../../utils/chapter";
import { Participant } from "../../../interfaces/Participant";

const CompleteChapter: React.FC = () => {
    const hist = useHistory();
    const { chapterId, isLibrary } = useParams<{ chapterId: string; isLibrary: string }>();
    const { currentParticipant, currentWeek } = useFetchUser();

    const handleComplete = async () => {
        if (currentParticipant && currentParticipant.id) {
            if (isChapterCompleted(chapterId, currentParticipant)) {
                if (isLibrary === "true") {
                    return hist.push("/library");
                }
                hist.push("/home");
            } else {
                await completeChapter(currentParticipant.id, currentWeek, chapterId);
                updateCompletedChapterCount();
                await redirect();
            }
        }
    };

    const redirect = async () => {
        try {
            if (isLibrary === "true") {
                return hist.push("/library");
            }

            hist.push("/home");
        } catch (e) {
            console.error(e);
        }
    };

    const updateCompletedChapterCount = async () => {
        if (currentParticipant && currentParticipant.id && currentParticipant.uses) {
            const data = await getDoc(firebaseDoc(firestore, "Participants", currentParticipant.id));
            const participant = genDoc<Participant>()(data);

            if (participant && participant.id) {
                const index = participant.uses.findIndex(u => !u.end);
                if (index !== -1) {
                    if (participant.uses[index]) {
                        if (participant.uses[index].chaptersCompleted) {
                            participant.uses[index].chaptersCompleted.push(chapterId);
                        } else {
                            participant.uses[index].chaptersCompleted = [chapterId];
                        }
                        await updateDoc(firebaseDoc(firestore, "Participants", participant.id), {
                            uses: [...participant.uses],
                        });
                    }
                }
            }
        }
    };

    useEffect(() => {
        handleComplete();
    }, []);

    return <></>;
};

export default CompleteChapter;
